import { render, staticRenderFns } from "./dzsw.vue?vue&type=template&id=0078e5ce&scoped=true&"
import script from "./dzsw.vue?vue&type=script&lang=js&"
export * from "./dzsw.vue?vue&type=script&lang=js&"
import style0 from "./dzsw.vue?vue&type=style&index=0&id=0078e5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0078e5ce",
  null
  
)

export default component.exports